module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Legion-S2.62532a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Legion-S2.jpg
// module id = uzpy
// module chunks = 0